export enum EntrepriseOptionsEnum {
  ListExternalLinks = 'external_applications',
  RdvEnabled = 'rdv_enabled',
  NewsEnabled = 'news_enabled',
  LinkApplicationEnabled = 'link_applications_enabled'
}
